
import { motion, useReducedMotion } from "framer-motion";
import EventIcon from "../Images/EventIcon.svg";

export default function EventCard({ notification, index = 0 }) {
  const reduceMotion = useReducedMotion();

  return (
    <motion.div
      initial={reduceMotion ? false : { opacity: 0, y: 16 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{
        duration: 0.45,
        delay: index * 0.05,
        ease: "easeOut",
      }}
      className={`flex items-start gap-3 w-full py-4 transition-colors duration-300 ease-out hover:bg-white/[0.04] ${notification.type === "reward" ? "bg-[#362222]" : ""
        }`}
    >
      {/* Event Icon / Video Thumbnail */}
      <div className="w-12 h-12 shrink-0 rounded-xl bg-[#ffffff1a] flex items-center justify-center overflow-hidden">
        {notification.type === "video" ? (
          notification?.thumbnailUrl ? (
            <img
              src={notification.thumbnailUrl}
              className="w-12 h-12 rounded-xl object-cover"
              alt="Event thumbnail"
            />
          ) : (
            <img src={EventIcon} alt="Event icon" />
          )
        ) : (
          <span>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 16 16"
              fill="none"
            >
              <path
                d="M8 4.90137V13.0264M8 4.90137H5.79018C5.46457 4.90137 5.15231 4.76967 4.92208 4.53525C4.69184 4.30083 4.5625 3.98289 4.5625 3.65137C4.5625 3.31985 4.69184 3.0019 4.92208 2.76749C5.15231 2.53306 5.46457 2.40137 5.79018 2.40137C7.50894 2.40137 8 4.90137 8 4.90137ZM8 4.90137H10.2098C10.5354 4.90137 10.8477 2.53306 11.0779 2.76749C11.3081 3.0019 11.4375 3.31985 11.4375 3.65137C11.4375 3.98289 11.3081 4.30083 11.0779 4.53525C10.8477 4.76967 10.5354 4.90137 10.2098 4.90137C8.49106 4.90137 8 4.90137 8 4.90137ZM3.625 8.02637H12.375V11.6514C12.375 12.3514 12.375 12.7015 12.2387 12.9689C12.1189 13.2041 11.9277 13.3953 11.6925 13.5151C11.4251 13.6514 11.0751 13.6514 10.375 13.6514H5.625C4.92493 13.6514 4.5749 13.6514 4.30751 13.5151C4.07231 13.3953 3.88108 13.2041 3.76124 12.9689C3.625 12.7015 3.625 12.3514 3.625 11.6514V8.02637ZM3.375 8.02637H12.625C12.9751 8.02637 13.1501 8.02637 13.2838 7.95824C13.4014 7.8983 13.4969 7.80274 13.5569 7.68512C13.625 7.55143 13.625 7.37643 13.625 7.02637V5.90137C13.625 5.55134 13.625 5.37632 13.5569 5.24262C13.4969 5.12502 13.4014 5.02941 13.2838 4.96949C13.1501 4.90137 12.9751 4.90137 12.625 4.90137H3.375C3.02497 4.90137 2.84995 4.90137 2.71626 4.96949C2.59866 5.02941 2.50304 5.12502 2.44312 5.24262C2.375 5.37643 2.375 5.55134 2.375 5.90137V7.02637C2.375 7.37643 2.375 7.55143 2.44312 7.68512C2.50304 7.80274 2.59866 7.8983 2.71626 7.95824C2.84995 8.02637 3.02497 8.02637 3.375 8.02637Z"
                stroke="white"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
                fill="#ffff"
              />
            </svg>
          </span>
        )}
      </div>

      {/* Notification Content */}
      <div className="flex-1 min-w-0 flex flex-col gap-0.5">
        {/* Tag */}
        <h3 className="w-full text-left text-[13px]  font-medium whitespace-normal ">
          {notification?.tag}
        </h3>

        {/* Title, Section, and Module */}
        <div className="flex flex-col w-full min-w-0">
          <h2 className="hidden md:block w-full text-left text-[11px] text-[#A0AEC0] whitespace-nowrap">
            {`Titre: ${notification?.title || notification?.Titre || ""}`}
          </h2>

          {notification.type === "video" && (
            <>
              <h2 className="hidden md:block w-full text-left text-[11px] text-[#A0AEC0] whitespace-nowrap">
                {`Section: ${notification?.section || ""}`}
              </h2>

              <h2 className="hidden md:block w-full text-left text-[11px] text-[#A0AEC0] whitespace-nowrap">
                {`Module: ${notification?.module || ""}`}
              </h2>
            </>
          )}
        </div>
      </div>

      {/* Date */}
      <div className="shrink-0 self-start">
        <h3 className="text-[11px] md:text-[13px] font-medium text-right whitespace-nowrap">
          {notification?.timestamp?.toDate().toLocaleDateString()}
        </h3>
      </div>
    </motion.div>
  );
}